__turbopack_context__.v({
  "separator": "separator-module-scss-module__WL4hjq__separator",
});
